import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid';
import { AppBar, Box, Button, Checkbox, Menu, MenuItem, Modal, Stack, Toolbar, Typography } from '@mui/material';
import './Nlayout.css'
import { Link, useLocation } from 'react-router-dom'
import { FaBagShopping, FaDiscord, FaFacebook, FaInstagram, FaKickstarterK, FaYoutube, FaGlobe, FaShield, FaGift, FaTrophy, FaSquarePlus, FaRightFromBracket, FaDice } from 'react-icons/fa6';
import logo from './img/logoDs.png'
import logoDengue from './logoDengue.webp'
import backg from './main_intro.jpg'
import { generatePKCE } from './api/pkce';
import { IoCloseCircleOutline, IoTimeOutline } from "react-icons/io5";
import { IoMdArrowDropdown, IoMdHome, IoMdNotificationsOutline, IoIosArrowForward } from "react-icons/io";
import { PiRankingFill, PiTipJarDuotone } from "react-icons/pi";
import gamble from './gambleAware.svg'
import { FaFacebookSquare } from 'react-icons/fa';
import { FaCrown } from 'react-icons/fa';
import { TbRating18Plus, TbReceipt } from "react-icons/tb";
import { MdVerified } from 'react-icons/md';
import { IoIosSunny, IoMdClose, IoMdDownload, IoMdMenu } from 'react-icons/io';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { motion, AnimatePresence } from 'framer-motion';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import coin from './Wild_coin.png'
import axios from 'axios';
import Loader from './Loader';
import { useAuth } from './authContext';
import ApelarBlacklistModal from './components/ApelarBlacklistModal';

const buttonBase = {
    px: 3,
    py: 1.5,
    fontSize: '1rem',
    fontWeight: 'bold',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '12px',
    background: 'transparent',
    transition: '0.3s ease',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
};
function Nlayout(props) {
    const { username, logout } = useAuth();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const [user, setUser] = useState(null); // State to store user data (name, logged-in status)



    const redirectUri = "/callback";
    const clientId = "01JW6K1RY4R70K7B6KSJ8GK5CV";
    const scope = "user"; // según lo que pediste



    const loginWithKick = async () => {

        const { code_verifier, code_challenge } = await generatePKCE();
        localStorage.setItem('kick_code_verifier', code_verifier);

        const criptoRandom = crypto.randomUUID()

        const params = new URLSearchParams({
            response_type: 'code',
            client_id: '01JW6K1RY4R70K7B6KSJ8GK5CV',
            redirect_uri: 'https://eldenguee.com/callback',
            scope: 'chat:write channel:read user:read events:subscribe',
            code_challenge: code_challenge,
            code_challenge_method: 'S256',
            state: criptoRandom,
        });

        window.location.href = `https://id.kick.com/oauth/authorize?${params.toString()}`;
    };



    const tokenKick = localStorage.getItem('kick_token');

    const parsedToken = JSON.parse(tokenKick);


    const fetchUserDataKick = async (accessToken) => {

        try {
            const response = await fetch('https://api.kick.com/public/v1/users', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const userData = await response.json();

            localStorage.setItem('kick_user', userData?.data[0]?.name); // Guarda los datos del usuario
            localStorage.setItem('kick_mail', userData?.data[0]?.email); // Guarda los datos del usuario
            const userName = userData?.data[0]?.name;

            setUser({
                name: userData?.data[0]?.name, email: userData?.data[0]?.email, profile: userData?.data[0]?.profile_picture
            });
            // 👇 Si el usuario es "eldenguee", enviamos los tokens a tu backend
            if (userName === 'eldenguee') {
                await saveTokensToBackend(userName, parsedToken?.access_token, parsedToken?.refresh_token);
            }
            return userData;
        } catch (err) {
            console.error('Error al obtener los datos del usuario:', err);
            throw err;
        }
    };
    // 🔥 Nueva función para enviar tokens a tu backend
    const saveTokensToBackend = async (username, accessToken, refreshToken) => {
        try {
            await fetch('https://backend.eldenguee.com/sorteo/kick/actualizar-tokens', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username,
                    access_token: accessToken,
                    refresh_token: refreshToken,
                }),
            });
            console.log('✅ Tokens guardados correctamente en la BD');
        } catch (err) {
            console.error('❌ Error al guardar los tokens:', err);
        }
    };
    useEffect(() => {
        if (!tokenKick) return; // No ejecutar si tokenKick es null o undefined
        // login()
    }, [tokenKick])

    // const login = async () => {

    //     try {

    //         const response = await fetch(
    //             "https://backend.eldenguee.com/auth/login",
    //             {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify({
    //                     access_token: parsedToken.access_token
    //                 })
    //             }
    //         );

    //         if (!response.ok) {

    //             throw new Error("Error login");

    //         }

    //         const data = await response.json();

    //         localStorage.setItem("jwt", data.token);

    //         setUser(data.user);

    //     } catch (err) {

    //         console.log(err);

    //     }

    // }
    useEffect(() => {
        if (!tokenKick) return; // No ejecutar si tokenKick es null o undefined
        fetchUserDataKick(parsedToken?.access_token)
    }, [tokenKick])

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const [comunidadAnchorEl, setComunidadAnchorEl] = useState(null);
    const openComunidad = Boolean(comunidadAnchorEl);
    const [Dcoins, setDcoins] = useState(0);

    // Maneja el clic para abrir el menú de usuario
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Maneja el cierre del menú de usuario
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    // Maneja el clic para abrir el menú de comunidad
    const handleComunidadClick = (event) => {
        setComunidadAnchorEl(event.currentTarget);
    };

    // Maneja el cierre del menú de comunidad
    const handleComunidadClose = () => {
        setComunidadAnchorEl(null);
    };


    // Maneja el clic en "Cerrar sesión"
    const handleLogout = () => {
        handleCloseMenu(); // Cierra el dropdown
        setUser(null);
        localStorage.removeItem('fbUser');
        localStorage.removeItem('fbAccessToken');
        localStorage.removeItem('kick_code_verifier');
        localStorage.removeItem('kick_token');
        localStorage.removeItem('kick_user');
        localStorage.removeItem('kick_jwt');
        console.log('User logged out');

        handleClose(); // Cierra el modal de login si estuviera abierto
        window.location.href = "/";
    };
    const [solicitudes, setSolicitudes] = useState()
    const [bonos, setBonos] = useState()
    const [bonos2da, setBonos2da] = useState()
    const nombre = localStorage.getItem('kick_user')

    // --- Estado Blacklist ---
    const [isInBlacklist, setIsInBlacklist] = useState(null); // null = cargando
    const [apelarModalOpen, setApelarModalOpen] = useState(false);

    useEffect(() => {
        if (!nombre) return;
        const checkBlacklist = async () => {
            try {
                const apiKey = process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026';
                const { data } = await axios.get(
                    `https://backend.eldenguee.com/solicitudes/${nombre}/blacklist`,
                    {
                        headers: {
                            "x-internal-api-key": apiKey,
                            "x-api-key": apiKey
                        }
                    }
                );
                const listed = data?.blacklist ?? false;
                setIsInBlacklist(listed);
            } catch {
                setIsInBlacklist(false);
            }
        };
        checkBlacklist();
    }, [nombre]);

    // --- Mis Solicitudes ---
    const [misSolicitudes, setMisSolicitudes] = useState([]);

    useEffect(() => {
        if (!nombre || nombre === 'lucaslunacl' || nombre === 'eldenguee') return;
        const fetchMisSolicitudes = async () => {
            try {
                const { data } = await axios.get(
                    `https://backend.eldenguee.com/solicitudes/${nombre}/mis-solicitudes`
                );
                setMisSolicitudes(Array.isArray(data) ? data : []);
            } catch {
                setMisSolicitudes([]);
            }
        };
        fetchMisSolicitudes();
    }, [nombre]);

    const obtenerCoins = async () => {
        const response = await axios.post('https://backend.eldenguee.com/solicitudes/usuario', { nombre });
        setDcoins(response?.data[0]?.Dcoins)
        setSolicitudes(response?.data[0]?.solicitudes)
        setBonos(response?.data[0]?.bonos)
        setBonos2da(response?.data[0]?.Bono2da)
    }

    useEffect(() => {
        obtenerCoins();
    }, []);

    // --- Notificaciones ---
    const [notificaciones, setNotificaciones] = useState([]);
    const [notifOpen, setNotifOpen] = useState(false);
    const [notifAnchorEl, setNotifAnchorEl] = useState(null);

    const fetchNotificaciones = async () => {
        if (!nombre) return;

        try {
            const { data } = await axios.get(
                `https://backend.eldenguee.com/notificaciones/${nombre}`
            );

            setNotificaciones(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error obteniendo notificaciones:", error);
            setNotificaciones([]);
        }
    };

    useEffect(() => {
        if (nombre) {
            fetchNotificaciones();
        }
    }, [nombre]);

    const marcarComoLeida = async (id) => {
        try {
            await axios.put(`https://backend.eldenguee.com/notificaciones/${id}/leida`);

            setNotificaciones(prev =>
                prev.map(n =>
                    n.id === id
                        ? {
                            ...n,
                            leida: true,
                            fecha_lectura: new Date().toISOString()
                        }
                        : n
                )
            );
        } catch (error) {
            console.error("Error marcando notificación:", error);
        }
    };

    const unreadCount = notificaciones.filter(n => !n.leida).length;

    const handleNotifOpen = (e) => {
        console.log('event', e)
        setNotifAnchorEl(e.currentTarget);
        setNotifOpen(true);
    };

    const handleNotifClose = () => {
        setNotifOpen(false);
        setNotifAnchorEl(null);
    };

    const toPanel = () => {
        window.location.href = "/panel"
    }
    const toCrearCode = () => {
        window.location.href = "/crearCode"
    }
    const toCrearTorneo = () => {
        window.location.href = "/crearTorneo"
    }
    const toCrearPrediccion = () => {
        window.location.href = "/crearPrediccion"
    }
    const toCanjearCode = () => {
        window.location.href = "/menu-tipeos"
    }
    const toListaCodigos = () => {
        window.location.href = "/listaCodigos"
    }
    const toPanelSorteo = () => {
        window.location.href = "/listado"
    }
    const toPanelAudios = () => {
        window.location.href = "/listaaudios"
    }
    const toPanelTorneo = () => {
        window.location.href = "/listadoTorneos"
    }
    const toPanelNoReclamados = () => {
        window.location.href = "/listanoreclamados"
    }
    const toPanelEventos = () => {
        window.location.href = "/eventos"
    }
    const toShop = () => {
        window.location.href = "/shop"
    }
    const toGuides = () => {
        window.location.href = "/guias"
    }
    const toVip = () => {
        window.location.href = "/rankings"
    }
    const toListadoRankings = () => {
        window.location.href = "/listadoRankings"
    }
    const toListadoBlacklist = () => {
        window.location.href = "/blacklist"
    }
    const toListadoBlacklistPublica = () => {
        window.location.href = "/listaBlacklist"
    }

    const [width, setWidth] = useState(window.innerWidth);

    const isMobile = width <= 768;

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const jwtToken = localStorage.getItem('kick_jwt') || localStorage.getItem('session_token') || localStorage.getItem('accessToken') || '';
    const cleanKickUser = String(username || localStorage.getItem('kick_user') || '').replace(/['"]/g, '').trim().toLowerCase();
    const cleanKickMail = String(localStorage.getItem('kick_mail') || '').replace(/['"]/g, '').trim().toLowerCase();
    const isEldengueeOrLucas =
        ['eldenguee', 'lucaslunacl'].includes(cleanKickUser) ||
        ['lucaslunaclaraso@gmail.com', 'chinosc.96@gmail.com', 'eldenguee@gmail.com'].includes(cleanKickMail);
    const isValidUser = isEldengueeOrLucas;

    const isLoggedIn = username;
    const profilePic = user?.profile || user?.profile_picture || localStorage.getItem('kick_profile');
    const redirectTipeo = () => {
        window.location.href = "/tipeo"

    }
    const redirectBonos = () => {
        window.location.href = "/bonos"
    }
    const redirectBonus = () => {
        window.location.href = "/bonus1xbet"
    }

    const redirectShop = () => {
        window.location.href = "/shop"

    }
    const redirectSolicitudes = () => {
        window.location.href = "/solicitudes"
    }
    const darCoins = () => {

        const route =
            localStorage.getItem("route_coins");

        window.location.href =
            `/panel/${route}`;

    };


    const darTipeo = () => {

        const route =
            localStorage.getItem("route_tipeos");

        window.location.href =
            `/panel/${route}`;

    };

    const limiteTipeos = () => {
        const route = localStorage.getItem("route_limite_tipeos");
        window.location.href = `/panel/${route}`;
    };

    const enviarPush = () => {
        const route = localStorage.getItem("route_enviar_push");
        window.location.href = `/panel/${route}`;
    };
    const redirectAcreditaciones = () => {
        window.location.href = "/acreditaciones";
    };
    const redirectCrearSolicitudes = () => {
        window.location.href = "/crearlink"
    }
    const redirectListadoLinks = () => {
        window.location.href = "/listalinks"
    }
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Mostrar loader en carga inicial
        setLoading(true);
        const timer = setTimeout(() => setLoading(false), 1000); // duración del loader
        return () => clearTimeout(timer);
    }, [location.pathname]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [mobileNotifOpen, setMobileNotifOpen] = useState(false);

    const toggleMobileMenu = () => setMenuOpen(!menuOpen);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'rgba(20, 20, 20, 0.95)',
        borderRadius: 4,
        boxShadow: 24,
        backdropFilter: 'blur(8px)',
        textAlign: 'center',
        backgroundImage: `
        linear-gradient(to bottom,  rgba(63, 61, 69, 0),rgb(73 22 227)),
        url(${backg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        padding: isMobile ? '35px' : '150px 56px 56px'
    };

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const [progress, setProgress] = useState(100);
    const duration = 5000; // 5 segundos
    const [openModal, setOpenModal] = useState(false)
    useEffect(() => {
        if (openModal) {
            setProgress(100); // <-- Reset progress

            let interval = setInterval(() => {
                setProgress((prev) => {
                    if (prev <= 0) {
                        clearInterval(interval);
                        if (openModal) {
                            setOpenModal(false);
                        }
                        return 0;
                    }
                    return prev - 2;
                });
            }, duration / 50);

            return () => clearInterval(interval);
        }
    }, [openModal]);
    const notificacionesPendientes = notificaciones.filter(n => !n.leida);
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

            <div className='header' style={{ padding: isMobile ? 5 : 10 }}>
                <Toolbar style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: isMobile ? '100%' : '90%', margin: '0 auto', padding: isMobile ? '0 10px' : 0 }}>

                    {/* Sección Izquierda / Centro */}
                    <Grid style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '10px' : '20px' }}>
                        {/* Logo */}
                        <Link to="/" className="logo-link" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                            <img src={logo} alt="D'S Logo" style={{ height: isMobile ? '30px' : '36px', objectFit: 'contain', filter: 'drop-shadow(0 0 12px rgba(212,175,55,.4))' }} />
                        </Link>

                        {/* Enlaces de Navegación (Solo escritorio) */}

                    </Grid>
                    {
                        !isMobile &&


                        <Grid className="nav-menu" style={{ flexGrow: 1, justifyContent: 'center' }}>
                            <Link
                                to="/"
                                className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}
                            >
                                Inicio
                            </Link>

                            <Link
                                to="/shop"
                                className={`nav-item ${location.pathname === '/shop' ? 'active' : ''}`}
                            >
                                Shop
                            </Link>

                            <Link
                                to="/menu-tipeos"
                                className={`nav-item tipeos-item ${location.pathname === '/menu-tipeos' || location.pathname === '/tipeo' ? 'active' : ''}`}
                            >
                                Tipeos
                            </Link>

                            <Link
                                to="/guias"
                                className={`nav-item  ${location.pathname === '/guias' || location.pathname === '/guias' ? 'active' : ''}`}
                            >
                                Guías
                            </Link>

                            <Link
                                to="/rankings"
                                className={`nav-item ${location.pathname === '/rankings' ? 'active' : ''}`}
                            >
                                Rankings
                            </Link>
                            <Link
                                to="/listaBlacklist"
                                className={`nav-item ${location.pathname === '/listaBlacklist' ? 'active' : ''}`}
                            >
                                Blacklist
                            </Link>

                            {isInBlacklist && (
                                <div
                                    onClick={() => setApelarModalOpen(true)}
                                    className="nav-item"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        color: '#ef4444',
                                        fontWeight: 700,
                                        cursor: 'pointer',
                                        padding: '4px 10px',
                                        borderRadius: '8px',
                                        backgroundColor: 'rgba(239, 68, 68, 0.12)',
                                        border: '1px solid rgba(239, 68, 68, 0.3)'
                                    }}
                                >
                                    <FaShield style={{ color: '#ef4444' }} /> Apelar Blacklist
                                </div>
                            )}

                            <div
                                onClick={handleComunidadClick}
                                className="nav-item"
                                style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                            >
                                Comunidad <IoMdArrowDropdown style={{ fontSize: '16px' }} />
                            </div>
                        </Grid>
                    }
                    {/* Sección Derecha (Idioma + Login / Perfil) */}
                    <Grid style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '8px' : '15px' }}>
                        {/* Selector de idioma */}
                        {/* {!isMobile && (
                            <button className="lang-selector-pill">
                                <FaGlobe size={16} />
                                <span>ES</span>
                            </button>
                        )} */}

                        {/* Estado de Autenticación */}
                        {username ? (
                            <Grid style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '8px' : '15px' }}>
                                {/* Coins */}
                                <Grid style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '99px', background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255,255,255,0.08)' }}>
                                    <img src={coin} style={{ width: '18px', height: '18px' }} alt="Coins" />
                                    <Typography style={{ fontSize: 14, fontFamily: 'Outfit,sans-serif', color: 'hsla(0,0%,100%,.75)', fontWeight: 'bold' }}>{Number(Dcoins ?? 0).toLocaleString('es-AR')}</Typography>
                                </Grid>

                                {/* Notificaciones */}
                                <div
                                    id="notif-bell-btn"
                                    onClick={(e) => {
                                        if (isMobile) {

                                            setMobileNotifOpen(!mobileNotifOpen);
                                        } else {

                                            handleNotifOpen(e);
                                        }
                                    }}
                                    style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)', transition: 'background 0.2s' }}
                                    title="Notificaciones"
                                >
                                    <NotificationsIcon style={{ fontSize: '22px', color: unreadCount > 0 ? 'white' : 'hsla(0,0%,100%,.7)' }} />
                                    {unreadCount >= 0 && (
                                        <span style={{
                                            position: 'absolute', top: '-4px', right: '-4px',
                                            background: 'rgb(252,215,96)', color: 'black',
                                            borderRadius: '99px', fontSize: '10px',
                                            fontWeight: 'bold', fontFamily: 'Outfit,sans-serif',
                                            minWidth: '16px', height: '16px',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            padding: '0 3px', border: '1.5px solid #0f0f1a'
                                        }}>{unreadCount > 9 ? '9+' : unreadCount}</span>
                                    )}
                                </div>

                                {/* Username */}
                                {/* {!isMobile && (
                                    <Typography sx={{
                                        color: '#ffffff',
                                        fontWeight: 700,
                                        fontSize: 14,
                                        textTransform: 'uppercase',
                                        fontFamily: 'Outfit,sans-serif'
                                    }}>
                                        {username}
                                    </Typography>
                                )} */}

                                {/* Avatar & Dropdown */}
                                <Grid style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }} onClick={handleClick}>
                                    <Grid style={{
                                        width: '38px',
                                        height: '38px',
                                        padding: '2px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 50%, #00ff73 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 0 12px rgba(168, 85, 247, 0.4)',
                                    }}>
                                        <img src={profilePic} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} alt="Profile" />
                                    </Grid>
                                    <IoMdArrowDropdown style={{ color: '#e9f4ff', fontSize: '18px' }} />
                                </Grid>
                            </Grid>
                        ) : (
                            <button className="btn-kick-login" onClick={handleOpen}>
                                Ingresar Con Kick
                            </button>
                        )}
                    </Grid>

                    {/* Menú de Comunidad */}
                    <Menu
                        anchorEl={comunidadAnchorEl}
                        open={openComunidad}
                        onClose={handleComunidadClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        PaperProps={{
                            sx: {
                                mt: 1.5,
                                backgroundColor: 'rgba(28,30,48,.95)',
                                color: '#ffffff',
                                borderRadius: 2,
                                minWidth: 150,
                                boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                border: '1px solid rgba(255,255,255,0.08)'
                            }
                        }}
                        style={{ zIndex: 99999 }}
                    >
                        <MenuItem onClick={() => { window.open('https://discord.com/invite/2SVdrpbmzb', '_blank'); handleComunidadClose(); }}>
                            <FaDiscord style={{ marginRight: '8px', color: '#5865F2' }} /> Discord
                        </MenuItem>
                        <MenuItem onClick={() => { window.open('https://www.youtube.com/eldenguee', '_blank'); handleComunidadClose(); }}>
                            <FaYoutube style={{ marginRight: '8px', color: '#FF0000' }} /> Eldenguee
                        </MenuItem>
                        <MenuItem onClick={() => { window.open('https://www.youtube.com/@dengueetimba', '_blank'); handleComunidadClose(); }}>
                            <FaYoutube style={{ marginRight: '8px', color: '#FF0000' }} /> DengueeTimba
                        </MenuItem>

                        <MenuItem onClick={() => { window.open('https://www.instagram.com/eldengueee', '_blank'); handleComunidadClose(); }}>
                            <FaInstagram style={{ marginRight: '8px', color: '#E1306C' }} /> Instagram
                        </MenuItem>
                    </Menu>

                    {/* Panel de Notificaciones */}
                    <Menu
                        anchorEl={notifAnchorEl}
                        open={notifOpen}
                        onClose={handleNotifClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                mt: 1.5,
                                backgroundColor: 'rgba(15,15,30,0.97)',
                                borderRadius: 3,
                                minWidth: 320,
                                maxWidth: 360,
                                maxHeight: 420,
                                overflowY: 'auto',
                                boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
                                border: '1px solid rgba(124,58,237,0.25)',
                                backdropFilter: 'blur(12px)',
                                '&::-webkit-scrollbar': { width: '4px' },
                                '&::-webkit-scrollbar-track': { background: 'transparent' },
                                '&::-webkit-scrollbar-thumb': { background: 'rgba(124,58,237,0.4)', borderRadius: '4px' },
                            }
                        }}
                        style={{ zIndex: 99999 }}
                    >
                        {/* Header del panel */}
                        <div style={{ padding: '14px 16px 10px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IoMdNotificationsOutline style={{ fontSize: '18px', color: '#a78bfa' }} />
                                <span style={{ color: '#fff', fontWeight: 700, fontSize: '14px', fontFamily: 'Outfit,sans-serif' }}>Notificaciones</span>
                            </div>
                            {notificaciones.length > 0 && (
                                <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', fontFamily: 'Outfit,sans-serif' }}>{notificacionesPendientes.length} {notificacionesPendientes.length === 1 ? 'mail' : 'mails'}</span>
                            )}
                        </div>

                        {/* Lista de notificaciones */}
                        {notificacionesPendientes.length === 0 ? (
                            <div style={{ padding: '32px 16px', textAlign: 'center' }}>
                                <div style={{ fontSize: '36px', marginBottom: '10px' }}><NotificationsIcon style={{ color: 'white' }} /></div>
                                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', fontFamily: 'Outfit,sans-serif', lineHeight: 1.5 }}>No tenés notificaciones todavía.<br />Acá vas a ver cuándo se enviaron tus mails.</div>
                            </div>
                        ) : (
                            notificacionesPendientes.map((notif, i) => {
                                const isRead = notif.leida;
                                const fecha = notif.fecha ? new Date(notif.fecha) : null;
                                const fechaStr = fecha ? fecha.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
                                const tipoIcono = notif.tipo === 'bono' ? '🎁' : notif.tipo === 'tipeo' ? '📝' : notif.tipo === 'sorteo' ? '🎰' : '📧';
                                return (
                                    <div
                                        key={notif._id || notif.id || i}
                                        style={{
                                            padding: '12px 16px',
                                            borderBottom: '1px solid rgba(255,255,255,0.05)',
                                            background: isRead ? 'transparent' : 'rgba(124,58,237,0.07)',
                                            display: 'flex',
                                            gap: '12px',
                                            alignItems: 'flex-start',
                                            transition: 'background 0.2s',
                                        }}
                                    >
                                        <div style={{ fontSize: '22px', lineHeight: 1, marginTop: '2px' }}>{tipoIcono}</div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ color: '#fff', fontSize: '13px', fontWeight: isRead ? 400 : 600, fontFamily: 'Outfit,sans-serif', lineHeight: 1.4 }}>
                                                {notif.titulo || 'Mail enviado'}
                                            </div>
                                            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontFamily: 'Outfit,sans-serif', marginTop: '3px' }}>
                                                {notif.descripcion || ''}
                                            </div>
                                            {fechaStr && (
                                                <div style={{ color: '#a78bfa', fontSize: '11px', fontFamily: 'Outfit,sans-serif', marginTop: '5px' }}>
                                                    🕐 {fechaStr}
                                                </div>
                                            )}
                                            {!isRead && (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); marcarComoLeida(notif._id || notif.id); }}
                                                    style={{
                                                        marginTop: '8px',
                                                        background: 'rgba(124,58,237,0.18)',
                                                        border: '1px solid rgba(124,58,237,0.4)',
                                                        borderRadius: '6px',
                                                        color: '#a78bfa',
                                                        fontSize: '11px',
                                                        fontFamily: 'Outfit,sans-serif',
                                                        fontWeight: 600,
                                                        padding: '3px 10px',
                                                        cursor: 'pointer',
                                                        transition: 'background 0.2s',
                                                    }}
                                                >
                                                    ✓ Marcar como leída
                                                </button>
                                            )}
                                        </div>
                                        {!isRead && (
                                            <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#7c3aed', flexShrink: 0, marginTop: '6px' }} />
                                        )}
                                    </div>
                                );
                            })
                        )}
                    </Menu>

                    {/* Menú de Usuario */}
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleCloseMenu}
                        disableScrollLock={true}
                        marginThreshold={0}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        style={{ zIndex: 99999 }}
                        PaperProps={{
                            sx: {
                                mt: 1,
                                backgroundColor: '#0c0f18',
                                backgroundImage: 'linear-gradient(180deg, #121624 0%, #0c0e17 100%)',
                                color: '#ffffff',
                                borderRadius: '18px',
                                width: 310,
                                maxWidth: '94vw',
                                maxHeight: 'none !important',
                                overflow: 'visible !important',
                                boxShadow: '0 20px 50px rgba(0, 0, 0, 0.85), 0 0 30px rgba(124, 58, 237, 0.12)',
                                border: '1px solid rgba(255, 255, 255, 0.08)',
                                backdropFilter: 'blur(16px)',
                                padding: '12px 14px',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: -6,
                                    right: 22,
                                    width: 12,
                                    height: 12,
                                    backgroundColor: '#121624',
                                    transform: 'rotate(45deg)',
                                    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                                    borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
                                    zIndex: 1,
                                },
                                '& .MuiList-root': {
                                    padding: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '1px',
                                    overflow: 'visible !important',
                                    maxHeight: 'none !important',
                                }
                            }
                        }}
                    >
                        {/* User Header Section */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pb: 1.2, mb: 0.8, borderBottom: '1px solid rgba(255, 255, 255, 0.08)' }}>
                            {/* Avatar with glowing ring */}
                            <Box sx={{
                                width: 58,
                                height: 58,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 50%, #00ff73 100%)',
                                padding: '2px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 0 16px rgba(168, 85, 247, 0.4)',
                                mb: 0.8
                            }}>
                                <img
                                    src={profilePic}
                                    alt="Profile"
                                    style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                                />
                            </Box>

                            {/* Username + Verified Badge */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: 16, color: '#ffffff', letterSpacing: '-0.01em' }}>
                                    {user?.name || username || 'Usuario'}
                                </Typography>
                                <MdVerified style={{ color: '#a855f7', fontSize: 18 }} />
                            </Box>

                            {/* Email */}
                            <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 11, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>
                                {user?.email || localStorage.getItem('kick_mail') || ''}
                            </Typography>

                            {/* Account Status Pill */}
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.8,
                                mt: 1,
                                px: 1.2,
                                py: 0.5,
                                borderRadius: '8px',
                                backgroundColor: 'rgba(255, 255, 255, 0.03)',
                                border: '1px solid rgba(255, 255, 255, 0.06)',
                                width: '100%',
                                justifyContent: 'center'
                            }}>
                                <FaShield style={{ color: isInBlacklist ? '#ef4444' : '#00ff73', fontSize: 12 }} />
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10.5, color: 'rgba(255, 255, 255, 0.7)' }}>
                                    Estado de cuenta
                                </Typography>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10.5, fontWeight: 700, color: isInBlacklist ? '#ef4444' : '#00ff73', ml: 'auto' }}>
                                    {isInBlacklist === null ? '...' : isInBlacklist ? 'En blacklist' : 'No en blacklist'}
                                </Typography>
                            </Box>

                            {isInBlacklist && (
                                <MenuItem
                                    onClick={() => {
                                        handleCloseMenu();
                                        setApelarModalOpen(true);
                                    }}
                                    sx={{
                                        borderRadius: '10px',
                                        mt: 1,
                                        px: 1,
                                        py: 0.6,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                        border: '1px solid rgba(239, 68, 68, 0.35)',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(239, 68, 68, 0.25)',
                                            transform: 'translateX(3px)'
                                        }
                                    }}
                                >
                                    <FaShield style={{ color: '#ef4444', fontSize: 16 }} />
                                    <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 11.5, fontWeight: 700, color: '#ef4444' }}>
                                        Apelar Blacklist
                                    </Typography>
                                </MenuItem>
                            )}
                        </Box>

                        {/* Section: TUS SOLICITUDES */}
                        {misSolicitudes.length > 0 && nombre !== 'lucaslunacl' && nombre !== 'eldenguee' && (
                            <>
                                <Box sx={{ my: 0.5, borderTop: '1px solid rgba(255, 255, 255, 0.08)' }} />
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 9.5, fontWeight: 700, color: 'rgba(255, 255, 255, 0.4)', textTransform: 'uppercase', letterSpacing: '1px', px: 1, pt: 0.4, pb: 0.2 }}>
                                    TUS SOLICITUDES
                                </Typography>
                                {misSolicitudes.slice(0, 3).map((sol, i) => {
                                    const fecha = sol.createdAt
                                        ? new Date(sol.createdAt).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                        : '—';
                                    const estado = (sol.status || 'Pendiente').trim();
                                    const estadoLower = estado.toLowerCase();
                                    const isEntregada = estadoLower === 'accepted' || estadoLower.includes('entregad') || estadoLower.includes('aprobad');
                                    const isRechazada = estadoLower === 'rejected' || estadoLower.includes('rechazad') || estadoLower.includes('denegad');
                                    const estadoColor = isEntregada ? '#00ff73' : isRechazada ? '#ef4444' : '#f59e0b';
                                    const estadoBg = isEntregada ? 'rgba(0,255,115,0.1)' : isRechazada ? 'rgba(239,68,68,0.1)' : 'rgba(245,158,11,0.1)';
                                    const tipoLabel = sol.tipo === 'apelacion' || sol.casino === 'blacklist' ? 'Apelación Blacklist' : (sol.tipo === '1xBet' ? '1xBet' : sol.tipo === 'Bonus' ? 'Bonus' : 'Bonos');
                                    return (
                                        <Box key={i} sx={{ px: 1, py: 0.5, display: 'flex', flexDirection: 'column', gap: 0.3, borderRadius: '8px', '&:hover': { backgroundColor: 'rgba(255,255,255,0.04)' } }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10.5, color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>
                                                    {fecha} · Solicitud {tipoLabel}
                                                </Typography>
                                                <Box sx={{ px: 0.8, py: 0.2, borderRadius: '6px', backgroundColor: estadoBg, border: `1px solid ${estadoColor}33`, flexShrink: 0 }}>
                                                    <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 9.5, fontWeight: 700, color: estadoColor }}>
                                                        {estado}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {isRechazada && sol.motivo && (
                                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(239,68,68,0.8)', pl: 0.5 }}>
                                                    Motivo: {sol.motivo}
                                                </Typography>
                                            )}
                                        </Box>
                                    );
                                })}
                                <MenuItem
                                    onClick={() => {
                                        handleCloseMenu();
                                        window.location.href = "/mis-solicitudes";
                                    }}
                                    sx={{
                                        borderRadius: '8px',
                                        mt: 0.5,
                                        px: 1,
                                        py: 0.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 0.5,
                                        backgroundColor: 'rgba(168, 85, 247, 0.1)',
                                        border: '1px solid rgba(168, 85, 247, 0.25)',
                                        minHeight: 'unset',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(168, 85, 247, 0.2)',
                                        }
                                    }}
                                >
                                    <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 11, fontWeight: 700, color: '#a855f7' }}>
                                        Ver todas
                                    </Typography>
                                    <IoIosArrowForward style={{ color: '#a855f7', fontSize: 12 }} />
                                </MenuItem>
                            </>
                        )}

                        {/* Menu items - solo visibles para isValidUser */}
                        {(isValidUser) && (
                            <>
                                {/* Section: MI CUENTA */}
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 9.5, fontWeight: 700, color: 'rgba(255, 255, 255, 0.4)', textTransform: 'uppercase', letterSpacing: '1px', px: 1, pt: 0.4, pb: 0.2 }}>
                                    MI CUENTA
                                </Typography>

                                <MenuItem onClick={isLoggedIn && isValidUser ? darCoins : handleOpen} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(0, 255, 115, 0.1)', border: '1px solid rgba(0, 255, 115, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <img src={coin} style={{ width: 18, height: 18, objectFit: 'contain' }} alt="Coin" />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Dar Coins</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Enviá Coins a otros usuarios</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? darTipeo : handleOpen} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(168, 85, 247, 0.1)', border: '1px solid rgba(168, 85, 247, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <PiTipJarDuotone style={{ color: '#a855f7', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Dar Tipeo</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Enviá Tipeos a otros usuarios</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? limiteTipeos : handleOpen} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <TbReceipt style={{ color: '#f59e0b', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Límite de Tipeos</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Cupo de solicitudes disponibles</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? enviarPush : handleOpen} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(236, 72, 153, 0.1)', border: '1px solid rgba(236, 72, 153, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <IoMdNotificationsOutline style={{ color: '#ec4899', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Enviar Push</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Notificaciones a la app</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? redirectSolicitudes : handleOpen} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <TbReceipt style={{ color: '#3b82f6', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Solicitudes de tipeo</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Gestiona tus solicitudes</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>


                                <MenuItem onClick={isLoggedIn && isValidUser ? redirectAcreditaciones : handleOpen} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid rgba(16, 185, 129, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <TbReceipt style={{ color: '#10b981', fontSize: 18 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Acreditaciones de Tipeo</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Control de tipeos acreditados</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                {/* Section: COMUNIDAD */}
                                <Box sx={{ my: 0.5, borderTop: '1px solid rgba(255, 255, 255, 0.08)' }} />
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 9.5, fontWeight: 700, color: 'rgba(255, 255, 255, 0.4)', textTransform: 'uppercase', letterSpacing: '1px', px: 1, pt: 0.4, pb: 0.2 }}>
                                    COMUNIDAD
                                </Typography>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toPanelSorteo : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(168, 85, 247, 0.1)', border: '1px solid rgba(168, 85, 247, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaGift style={{ color: '#a855f7', fontSize: 16 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Lista de Sorteos</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Explora todos los sorteos</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toPanelTorneo : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(234, 179, 8, 0.1)', border: '1px solid rgba(234, 179, 8, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaTrophy style={{ color: '#eab308', fontSize: 15 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Lista de Torneos</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Explora los torneos activos</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toListadoRankings : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(249, 115, 22, 0.1)', border: '1px solid rgba(249, 115, 22, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaCrown style={{ color: '#f97316', fontSize: 15 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Lista de Rankings</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Rankings de usuarios</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toPanelNoReclamados : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(14, 165, 233, 0.1)', border: '1px solid rgba(14, 165, 233, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <IoTimeOutline style={{ color: '#0ea5e9', fontSize: 17 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Lista de No Reclamados</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Premios pendientes</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toListadoBlacklist : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(168, 85, 247, 0.1)', border: '1px solid rgba(168, 85, 247, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaShield style={{ color: '#a855f7', fontSize: 16 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Blacklist</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Usuarios bloqueados</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                {/* Section: CREAR */}
                                <Box sx={{ my: 0.5, borderTop: '1px solid rgba(255, 255, 255, 0.08)' }} />
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 9.5, fontWeight: 700, color: 'rgba(255, 255, 255, 0.4)', textTransform: 'uppercase', letterSpacing: '1px', px: 1, pt: 0.4, pb: 0.2 }}>
                                    CREAR
                                </Typography>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toPanel : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(168, 85, 247, 0.1)', border: '1px solid rgba(168, 85, 247, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaSquarePlus style={{ color: '#a855f7', fontSize: 17 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Crear Sorteo</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Crea un nuevo sorteo</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toCrearTorneo : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(168, 85, 247, 0.1)', border: '1px solid rgba(168, 85, 247, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaTrophy style={{ color: '#a855f7', fontSize: 16 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Crear Torneo</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Crea un nuevo torneo</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>

                                <MenuItem onClick={isLoggedIn && isValidUser ? toCrearPrediccion : ''} sx={{ borderRadius: '10px', px: 1, py: 0.6, display: 'flex', alignItems: 'center', gap: 1.2, minHeight: 'unset', transition: 'all 0.2s ease', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)', transform: 'translateX(3px)' } }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(0, 255, 115, 0.1)', border: '1px solid rgba(0, 255, 115, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FaDice style={{ color: '#00ff73', fontSize: 17 }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>Crear Predicción</Typography>
                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(255, 255, 255, 0.5)', mt: 0.1 }}>Gestioná apuestas y predicciones</Typography>
                                    </Box>
                                    <IoIosArrowForward style={{ color: 'rgba(255, 255, 255, 0.35)', fontSize: 13 }} />
                                </MenuItem>
                            </>
                        )}

                        {/* Section: Cerrar Sesión */}
                        <Box sx={{ my: 0.5, borderTop: '1px solid rgba(255, 255, 255, 0.08)' }} />
                        <MenuItem
                            onClick={logout}
                            sx={{
                                borderRadius: '10px',
                                px: 1,
                                py: 0.6,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.2,
                                minHeight: 'unset',
                                transition: 'all 0.2s ease',
                                '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.1)', transform: 'translateX(3px)' }
                            }}
                        >
                            <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(239, 68, 68, 0.12)', border: '1px solid rgba(239, 68, 68, 0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <FaRightFromBracket style={{ color: '#ef4444', fontSize: 15 }} />
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 12, fontWeight: 700, color: '#ef4444', lineHeight: 1.1 }}>Cerrar sesión</Typography>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: 10, color: 'rgba(239, 68, 68, 0.7)', mt: 0.1 }}>Salir de tu cuenta</Typography>
                            </Box>
                        </MenuItem>
                    </Menu>

                </Toolbar>
            </div>

            <Modal open={open} onClose={handleClose}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90vw' : 360,
                    backgroundColor: '#1a1a2e',
                    borderRadius: '16px',
                    padding: '32px 28px 28px',
                    outline: 'none',
                    boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '18px',
                    position: 'relative',
                }}>
                    {/* Close button */}
                    <Box
                        onClick={() => handleClose()}
                        sx={{
                            position: 'absolute',
                            top: '14px',
                            right: '14px',
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255,255,255,0.12)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.22)' }
                        }}
                    >
                        ✕
                    </Box>

                    {/* Kick Logo */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '8px',
                    }}>
                        <Box sx={{
                            width: '56px',
                            height: '56px',
                            borderRadius: '12px',
                            backgroundColor: '#00ff73',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <FaKickstarterK size={28} color="#000" />
                        </Box>
                        <Box sx={{ width: '40px', height: '3px', backgroundColor: '#00ff73', borderRadius: '2px' }} />
                    </Box>

                    {/* Title */}
                    <Typography sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '22px',
                        fontFamily: 'Outfit, sans-serif',
                        textAlign: 'center',
                        lineHeight: 1.3,
                    }}>
                        Confirmá que sos mayor de{' '}
                        <span style={{ color: '#00ff73' }}>18 años</span>{' '}
                        para continuar
                    </Typography>

                    {/* Subtitle */}
                    <Typography sx={{
                        color: 'rgba(255,255,255,0.65)',
                        fontSize: '13px',
                        fontFamily: 'Outfit, sans-serif',
                        textAlign: 'center',
                        lineHeight: 1.5,
                    }}>
                        Leé y aceptá los{' '}
                        <span style={{ color: '#00ff73', cursor: 'pointer', textDecoration: 'underline' }}>términos y condiciones</span>
                        {' '}para acceder a{' '}
                        <span style={{ color: 'rgba(255,255,255,0.85)' }}>eldenguee.com</span>
                    </Typography>

                    {/* Checkbox */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '8px', width: '100%' }}>
                        <Checkbox
                            {...label}
                            sx={{
                                color: 'rgba(255,255,255,0.5)',
                                padding: '2px',
                                '&.Mui-checked': { color: '#00ff73' },
                            }}
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        <Typography sx={{
                            color: 'rgba(255,255,255,0.75)',
                            fontSize: '13px',
                            fontFamily: 'Outfit, sans-serif',
                            lineHeight: 1.5,
                            mt: '2px',
                        }}>
                            Confirmo que soy mayor de 18 años y leí los términos y condiciones de la página.
                        </Typography>
                    </Box>

                    {/* Kick Login Button */}
                    <Button
                        sx={{
                            color: 'black',
                            fontWeight: 'bold',
                            padding: '14px 0',
                            fontSize: '0.85rem',
                            letterSpacing: '0.08em',
                            width: '100%',
                            backgroundColor: '#00ff73',
                            border: '2px solid #00ff73',
                            borderRadius: '10px',
                            textTransform: 'uppercase',
                            fontFamily: 'Outfit, sans-serif',
                            transition: 'all 0.25s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            '&:hover': {
                                backgroundColor: '#00e666',
                                boxShadow: '0 0 20px rgba(0,255,115,0.4)',
                                transform: 'scale(1.02)',
                            },
                            '&.Mui-disabled': {
                                backgroundColor: 'rgba(0,255,115,0.25)',
                                color: 'rgba(0,0,0,0.4)',
                                border: '2px solid rgba(0,255,115,0.25)',
                            }
                        }}
                        startIcon={<FaKickstarterK size={18} />}
                        onClick={loginWithKick}
                        disabled={!isChecked}
                    >
                        Iniciar Sesión con Kick
                    </Button>
                </Box>
            </Modal>
            {loading && <Loader />}


            {!loading && props.children}



            <footer className="new-footer">
                <div className="new-footer-container">
                    {/* Left section: Copyright */}
                    <div className="new-footer-section">
                        <div className="shield-icon-wrapper">
                            <FaShield className="shield-icon" />
                        </div>
                        <div className="footer-text-block">
                            <div className="footer-text-title">© 2026 eldenguee.com</div>
                            <div className="footer-text-subtitle">Todos los derechos reservados.</div>
                        </div>
                    </div>

                    {/* Middle section: Responsible gambling */}
                    <div className="new-footer-section">
                        <div className="plus18-badge">18+</div>
                        <div className="footer-text-block">
                            <div className="footer-text-title">Juega con responsabilidad.</div>
                            <div className="footer-text-subtitle">El juego es entretenimiento, no una forma de ganar dinero.</div>
                        </div>
                    </div>

                    {/* Right section: GambleAware */}
                    <div className="new-footer-section right-aligned">
                        <img src={gamble} alt="GambleAware logo" className="gamble-aware-logo" />
                    </div>
                </div>
            </footer>

            {
                isMobile &&
                <>
                    <div className="mobile-menu">

                        <Link
                            to="/"
                            className={`mobile-menu-item${location.pathname === '/' ? ' mobile-menu-item--active' : ''}`}
                        >
                            <IoMdHome className="mobile-menu-icon" />
                            <span className="mobile-menu-label">Home</span>
                            {location.pathname === '/' && <span className="mobile-menu-indicator" />}
                        </Link>

                        {/* Tipeos */}
                        <a
                            onClick={() => toCanjearCode()}
                            className={`mobile-menu-item mobile-menu-item--tipeos${location.pathname === '/menu-tipeos' ? ' mobile-menu-item--active' : ''}`}
                        >
                            <PiTipJarDuotone className="mobile-menu-icon" />
                            <span className="mobile-menu-label">Tipeos</span>
                            {location.pathname === '/menu-tipeos' && <span className="mobile-menu-indicator" />}
                        </a>

                        {/* Shop */}
                        <a
                            onClick={() => toShop()}
                            className={`mobile-menu-item${location.pathname === '/shop' ? ' mobile-menu-item--active' : ''}`}
                        >
                            <FaBagShopping className="mobile-menu-icon" />
                            <span className="mobile-menu-label">Shop</span>
                            {location.pathname === '/shop' && <span className="mobile-menu-indicator" />}
                        </a>

                        {/* Guías */}
                        <a
                            onClick={() => toGuides()}
                            className={`mobile-menu-item${location.pathname === '/guias' ? ' mobile-menu-item--active' : ''}`}
                        >
                            <MenuBookIcon className="mobile-menu-icon" style={{ fontSize: 22 }} />
                            <span className="mobile-menu-label">Guías</span>
                            {location.pathname === '/guias' && <span className="mobile-menu-indicator" />}
                        </a>

                        {/* VIP */}
                        <a

                            onClick={() => toVip()}
                            className={`mobile-menu-item${location.pathname === '/rankings' ? ' mobile-menu-item--active' : ''}`}
                        >
                            <FaCrown className="mobile-menu-icon" />
                            <span className="mobile-menu-label">Rankings</span>
                            {location.pathname === '/rankings' && <span className="mobile-menu-indicator" />}
                        </a>
                        <a

                            onClick={() => toListadoBlacklistPublica()}
                            className={`mobile-menu-item${location.pathname === '/listaBlacklist' ? ' mobile-menu-item--active' : ''}`}
                        >
                            <FaCrown className="mobile-menu-icon" />
                            <span className="mobile-menu-label">Blacklist</span>
                            {location.pathname === '/listaBlacklist' && <span className="mobile-menu-indicator" />}
                        </a>

                        {isInBlacklist && (
                            <a
                                onClick={() => setApelarModalOpen(true)}
                                className="mobile-menu-item"
                                style={{ color: '#ef4444', cursor: 'pointer' }}
                            >
                                <FaShield className="mobile-menu-icon" style={{ color: '#ef4444' }} />
                                <span className="mobile-menu-label" style={{ color: '#ef4444', fontWeight: 700 }}>Apelar</span>
                            </a>
                        )}

                        {/* Notificaciones */}
                        {/* {username && (
                            <a
                                onClick={() => setMobileNotifOpen(true)}
                                className="mobile-menu-item"
                                style={{ position: 'relative' }}
                            >
                                <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <NotificationsIcon className="mobile-menu-icon" style={{ fontSize: 22 }} />
                                    {unreadCount > 0 && (
                                        <span style={{
                                            position: 'absolute', top: '-5px', right: '-7px',
                                            background: '#e0f644', color: 'black',
                                            borderRadius: '99px', fontSize: '9px',
                                            fontWeight: 'bold', fontFamily: 'Outfit,sans-serif',
                                            minWidth: '15px', height: '15px',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            padding: '0 3px', border: '1.5px solid #0f0f1a',
                                            lineHeight: 1,
                                        }}>{unreadCount > 9 ? '9+' : unreadCount}</span>
                                    )}
                                </span>
                                <span className="mobile-menu-label">Notifs</span>
                            </a>
                        )} */}

                    </div>

                    {/* Panel de Notificaciones Mobile (Drawer desde abajo) */}
                    {mobileNotifOpen && (
                        <div
                            onClick={() => setMobileNotifOpen(false)}
                            style={{
                                position: 'fixed', inset: 0,
                                background: 'rgba(0,0,0,0.55)',
                                zIndex: 99998,
                            }}
                        />
                    )}
                    <div style={{
                        position: 'fixed',
                        bottom: mobileNotifOpen ? 65 : '-100%',
                        left: 0, right: 0,
                        background: 'rgba(12,12,28,0.98)',
                        borderTop: '1px solid rgba(124,58,237,0.3)',
                        borderRadius: '20px 20px 0 0',
                        zIndex: 99999,
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        transition: 'bottom 0.35s cubic-bezier(0.4,0,0.2,1)',
                        boxShadow: '0 -8px 40px rgba(0,0,0,0.5)',
                        backdropFilter: 'blur(14px)',
                    }}>
                        {/* Handle */}
                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px', paddingBottom: '4px' }}>
                            <div style={{ width: '36px', height: '4px', borderRadius: '99px', background: 'rgba(255,255,255,0.18)' }} />
                        </div>

                        {/* Header */}
                        <div style={{ padding: '10px 16px 10px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IoMdNotificationsOutline style={{ fontSize: '18px', color: '#a78bfa' }} />
                                <span style={{ color: '#fff', fontWeight: 700, fontSize: '14px', fontFamily: 'Outfit,sans-serif' }}>Notificaciones</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {notificaciones.length > 0 && (
                                    <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', fontFamily: 'Outfit,sans-serif' }}>{notificacionesPendientes.length} {notificacionesPendientes.length === 1 ? 'pendiente' : 'pendientes'}</span>
                                )}
                                <button
                                    onClick={() => setMobileNotifOpen(false)}
                                    style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '50%', width: '26px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white', fontSize: '14px' }}
                                >✕</button>
                            </div>
                        </div>

                        {/* Lista */}
                        {notificacionesPendientes.length === 0 ? (
                            <div style={{ padding: '32px 16px', textAlign: 'center' }}>
                                <div style={{ fontSize: '36px', marginBottom: '10px' }}><NotificationsIcon style={{ color: 'rgba(255,255,255,0.3)', fontSize: '40px' }} /></div>
                                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', fontFamily: 'Outfit,sans-serif', lineHeight: 1.5 }}>No tenés notificaciones todavía.<br />Acá vas a ver cuándo se enviaron tus mails.</div>
                            </div>
                        ) : (
                            notificacionesPendientes.map((notif, i) => {
                                const isRead = notif.leida;
                                const fecha = notif.fecha ? new Date(notif.fecha) : null;
                                const fechaStr = fecha ? fecha.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
                                const tipoIcono = notif.tipo === 'bono' ? '🎁' : notif.tipo === 'tipeo' ? '📝' : notif.tipo === 'sorteo' ? '🎰' : '📧';
                                return (
                                    <div
                                        key={notif._id || notif.id || i}
                                        style={{
                                            padding: '12px 16px',
                                            borderBottom: '1px solid rgba(255,255,255,0.05)',
                                            background: isRead ? 'transparent' : 'rgba(124,58,237,0.07)',
                                            display: 'flex', gap: '12px', alignItems: 'flex-start',
                                        }}
                                    >
                                        <div style={{ fontSize: '22px', lineHeight: 1, marginTop: '2px' }}>{tipoIcono}</div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ color: '#fff', fontSize: '13px', fontWeight: isRead ? 400 : 600, fontFamily: 'Outfit,sans-serif', lineHeight: 1.4 }}>
                                                {notif.titulo || 'Mail enviado'}
                                            </div>
                                            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontFamily: 'Outfit,sans-serif', marginTop: '3px' }}>
                                                {notif.descripcion || ''}
                                            </div>
                                            {fechaStr && (
                                                <div style={{ color: '#a78bfa', fontSize: '11px', fontFamily: 'Outfit,sans-serif', marginTop: '5px' }}>🕐 {fechaStr}</div>
                                            )}
                                            {!isRead && (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); marcarComoLeida(notif._id || notif.id); }}
                                                    style={{
                                                        marginTop: '8px',
                                                        background: 'rgba(124,58,237,0.18)',
                                                        border: '1px solid rgba(124,58,237,0.4)',
                                                        borderRadius: '6px',
                                                        color: '#a78bfa',
                                                        fontSize: '11px',
                                                        fontFamily: 'Outfit,sans-serif',
                                                        fontWeight: 600,
                                                        padding: '3px 10px',
                                                        cursor: 'pointer',
                                                    }}
                                                >✓ Marcar como leída</button>
                                            )}
                                        </div>
                                        {!isRead && (
                                            <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#7c3aed', flexShrink: 0, marginTop: '6px' }} />
                                        )}
                                    </div>
                                );
                            })
                        )}
                        <div style={{ height: '16px' }} />
                    </div>
                </>
            }

            <Modal open={openModal} onClose={() => setOpenModal(false)} disableAutoFocus>
                <AnimatePresence>
                    {(openModal) && (
                        <motion.div
                            initial={{ x: -300, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: -300, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            className="toast-container"
                        >
                            <div className="toast-content">
                                <div className="icon">💰</div>
                                <div className="text">
                                    <strong>{openModal && 'PROXIMAMENTE!'}</strong>
                                    {
                                        openModal &&
                                        <p>Estamos trabajando!</p>
                                    }
                                </div>
                                <button className="close-btn" onClick={() => {
                                    setOpenModal(false);

                                }}>×</button>
                            </div>
                            <div className={openModal ? "progress-bar" : "progress-bar-error"} style={{ width: `${progress}%` }} />
                        </motion.div>
                    )}
                </AnimatePresence>
            </Modal>

            <ApelarBlacklistModal
                open={apelarModalOpen}
                onClose={() => setApelarModalOpen(false)}
                isMobile={isMobile}
            />
        </div>
    )
}

export default Nlayout